<template>
  <div :class="{'fixed-margin': isFixed}">
    <nav class="bg-gray-800 w-full" :class="{'fixed z-10': isFixed}">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 fixed-height">
        <div class="flex items-center justify-between h-16">
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <router-link to="/">
                <img class="h-12 w-12" src="../assets/logo1.png" alt="Logo" width="48px" height="48px"/>
              </router-link>
            </div>
            <div class="hidden md:block">
              <div class="ml-10 flex items-baseline space-x-4">
                <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->
                <router-link class="link" to="/">Главная</router-link>
                <router-link class="link" to="/about">Общий обзор</router-link>
                <router-link class="link" to="/summaries"
                  >Обзоры на сайты</router-link
                >
                <router-link class="link link-sm" to="/usefuls"
                  >Полезности</router-link
                >
              </div>
            </div>
          </div>
          <div
            class="hidden md:block text-gray-300 hover:text-white cursor-pointer"
          >
            <span class="sr-only">Go to facebook</span>
            <a
              href="https://www.facebook.com/103086781708387"
              target="_blank"
              class="flex items-center px-3 py-2 text-sm font-medium"
            >
              <span class="mr-2">Мы на</span>
              <icon name="facebook-sm" width="24" height="24"></icon>
            </a>
          </div>
          <div class="-mr-2 flex md:hidden">
            <!-- Mobile menu button -->
            <button
              class="bg-gray-800 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
              @click="open = !open"
            >
              <span class="sr-only">Open main menu</span>
              <!--
              Heroicon name: menu

              Menu open: "hidden", Menu closed: "block"
            -->
              <svg
                class="h-6 w-6"
                :class="open ? 'hidden' : 'block'"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              <!--
              Heroicon name: x

              Menu open: "block", Menu closed: "hidden"
            -->
              <svg
                class="h-6 w-6"
                :class="!open ? 'hidden' : 'block'"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!--
      Mobile menu, toggle classes based on menu state.

      Open: "block", closed: "hidden"
    -->
      <div class="md:hidden" :class="{ hidden: !open }">
        <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
          <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->

          <router-link class="link link-sm" to="/">Главная</router-link>
          <router-link class="link link-sm" to="/about"
            >Общий обзор</router-link
          >
          <router-link class="link link-sm" to="/summaries"
            >Обзоры на сайты</router-link
          >
          <router-link class="link link-sm" to="/usefuls"
            >Полезности</router-link
          >
        </div>
        <div
          class="border-gray-700 border-t px-1 pt-2 pb-2 sm:px-2 text-gray-300 hover:text-white"
        >
          <a
            href="https://www.facebook.com/103086781708387"
            target="_blank"
            class="flex items-center px-3 py-2 text-sm font-medium"
          >
            <span class="mr-2">Перейти на</span>
            <icon name="facebook-sm" width="24" height="24"></icon>
          </a>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import throttle from "lodash/throttle";
export default {
  name: "Navigation",
  props: {
    msg: String,
  },
  data() {
    return {
      open: false,
      isFixed: false,
      curY: 0
    };
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 64 && window.scrollY < this.curY) {
        this.isFixed = true;
        this.open = false;
      }
      if (window.scrollY === 0 || window.scrollY > this.curY) {
        this.isFixed = false;
      }
      this.curY = window.scrollY;
    }
  },
  mounted() {
    window.addEventListener("scroll", throttle(this.handleScroll, 200));
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fixed-margin {
  margin-bottom: 64px;
}
.fixed-height {
  height: 64px;
}
.link {
  @apply px-3;
  @apply py-2;
  @apply rounded-md;
  @apply text-sm;
  @apply font-medium;
}
.link:not(.router-link-exact-active) {
  @apply text-gray-300;
  @apply hover:bg-gray-700;
  @apply hover:text-white;
}
.link.router-link-exact-active {
  @apply bg-gray-900;
  @apply text-white;
}
.link-sm {
  @apply block;
}
</style>
